module.exports = __webpack_public_path__ + "static/Deklaracja_CE_EN_516-2d58fda6147837febfc598b27ae28786.pdf";